<template>
  <div class="subject clearfix">
    <div class="fl" style="padding-top:10px">
        <div class="fl" style="margin-right:8px"><img src="../../assets/subject.png" alt=""></div>
        <div class="fr">
            <p>一年级-数学-人教课标版(上册) <el-tag effect="dark" type="warning" size="small" style="margin-left:6px"> 切换课本 </el-tag></p>
            <p style="margin-top:10px">1.1 正数和负数</p>
        </div>
    </div>
    <div class="fr" style="margin-right:30px">
      <el-row style="margin-bottom:15px">
        <el-button type="primary" size="small" style="margin-right:10px">智能组卷</el-button>
        <el-button type="primary" size="small">在线备课</el-button>
      </el-row>
      <el-row>
        <el-button type="primary" size="small" style="margin-right:10px">资源中心</el-button>
        <el-button type="primary" size="small">布置任务</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>

<style lang='less' scoped>
.subject{
    width: 810px;
    padding: 18px 10px;
    border-radius: 8px;
    background-color: #fff;
}
</style>
